if (!customElements.get('cart-variant-selector')) {
  customElements.define('cart-variant-selector', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.status = this.querySelector('[aria-live]');
      const parsedProperties = JSON.parse(this.querySelector('[data-cart-line-properties]')?.textContent || '{}');
      this.properties = Array.isArray(parsedProperties) ? {} : (parsedProperties || {});
      this.select?.addEventListener('change', this.onChange.bind(this));
    }

    async onChange(event) {
      const selectedVariant = Number(event.target.value);
      const currentVariant = Number(this.dataset.currentVariant);
      if (!selectedVariant || selectedVariant === currentVariant) return;

      const addedItem = {
        id: selectedVariant,
        quantity: Number(this.dataset.quantity) || 1,
        properties: this.properties
      };
      delete addedItem.properties._ah_preorder;
      if (this.dataset.sellingPlan) addedItem.selling_plan = Number(this.dataset.sellingPlan);

      this.select.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = '…';

      let addedKey = null;
      let previousTarget = null;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!cartResponse.ok) throw new Error('cart');
        const cartBeforeChange = await cartResponse.json();
        const normalizedProperties = JSON.stringify(Object.entries(addedItem.properties).sort(([a], [b]) => a.localeCompare(b)));
        previousTarget = cartBeforeChange.items.find((item) => {
          const itemProperties = JSON.stringify(Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)));
          const itemSellingPlan = item.selling_plan_allocation?.selling_plan?.id;
          return item.variant_id === selectedVariant
            && itemProperties === normalizedProperties
            && String(itemSellingPlan || '') === String(this.dataset.sellingPlan || '');
        });

        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [addedItem] })
        });
        if (!addResponse.ok) throw new Error('add');
        const addResult = await addResponse.json();
        addedKey = addResult.items?.[0]?.key;

        const removeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: this.dataset.lineKey, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error('remove');
        window.location.reload();
      } catch (error) {
        if (addedKey) {
          await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: addedKey,
              quantity: previousTarget?.key === addedKey ? previousTarget.quantity : 0
            })
          }).catch(() => {});
        }
        this.select.value = String(currentVariant);
        this.status.textContent = this.dataset.errorMessage || '';
        this.select.disabled = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
